import {
  useGoalsTranslations,
  useCampaignContributionCSVExport,
} from 'modules/iterableGoals/hooks';
import { SortInput } from 'modules/iterableGoals/types';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { Export16 } from 'ui/icons/aurora/16px/Export16';
import { spacing } from 'ui/theme';

type ExportButtonPropType = {
  isDisabled: boolean;
  sort: SortInput;
  startTime: string;
  endTime: string;
  goalName: string;
};

export const ExportButton = ({
  goalName,
  startTime,
  endTime,
  sort,
  isDisabled,
}: ExportButtonPropType) => {
  const { t } = useGoalsTranslations();
  const {
    exportCSVHandler,
    linkProps,
    loading: exportLoading,
    CSVLinkWrapper,
  } = useCampaignContributionCSVExport();

  const handleExport = () =>
    exportCSVHandler({
      goalName,
      startTime,
      endTime,
      sort: {
        by: sort.sortBy,
        direction: sort.sortDirection,
      },
    });

  return (
    <Button
      data-test="campaign-contribution-export-button"
      isDisabled={isDisabled || exportLoading}
      size={BUTTON_SIZES.LARGE}
      variant={BUTTON_VARIANTS.SECONDARY}
      onClick={handleExport}
    >
      <Export16 style={{ marginRight: spacing.threeQuarter }} />
      {t('labels.campaignContributions.export.buttonLabel')}
      <CSVLinkWrapper {...linkProps} />
    </Button>
  );
};
